module.exports = __webpack_public_path__ + "static/media/steve.35e30fa0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/steve.jpg
// module id = 375
// module chunks = 17